import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, makeStyles } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

import { minAccordionStyle } from '../styles';
import FormSectionHeader from "../FormSectionHeader";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: 0, 
    paddingRight: 0
  },
  accordion: {
    margin: '0px !important'
  }
})) 

function SectionExpand(props) {
  let { title, editable, onEditClick, accordionProps, children, ...rest } = props;
  let accordionStyle = minAccordionStyle();
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  let [expand, setExpand] = useState(true);

  return (
    <Accordion
      className={classes.accordion}
      elevation={0}
      expanded={expand}
      {...rest}
    >
      <AccordionSummary
        className={`${accordionStyle.expanded} ${accordionStyle.summarySmall}`}
        expandIcon={editable ? null : <ExpandMore />}
        IconButtonProps={{
          onClick: () => { setExpand((prev) => !prev) }
        }}
        {...accordionProps}
      >
        <FormSectionHeader
          title={title}
          buttonText={t('common:edit')}
          onButtonClick={editable ? onEditClick : undefined}
        />
      </AccordionSummary>
      <AccordionDetails className={classes.root}>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default SectionExpand;